<template>
   <transition name="modal">
      <div class="modal-mask">
         <div class="modal-wrapper">
            <div class="modal-container">
               <div v-if="!hideClose" class="modal-close-btn" @click="handleClose">
                  X
               </div>

               <div class="modal-head">
                  <slot name="header">
                  </slot>
               </div>

               <div class="modal-subhead">
                  <slot name="subhead">
                  </slot>
               </div>

               <div class="modal-body">
                  <slot name="body">
                     default body
                  </slot>
               </div>

               <div class="modal-foot">
                  <slot name="footer">
                     default footer
                     <button class="modal-default-button" @click="handleClose">
                        OK
                     </button>
                  </slot>
               </div>
            </div>
         </div>
      </div>
   </transition>
</template>

<script>
import { mapActions } from 'vuex';

export default {
   props: {
      hideClose: Boolean,
      headerText: String,
      subHeadText: String,
      bodyText: String,
      footerText: String
   },

   methods: {
      ...mapActions('global', ['closeModal']),

      handleClose() {
         this.closeModal();
      }
   },

}
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 900px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: rgba(0, 0, 0, .93);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  border: 2px solid #7e8084;
  text-align:center;
}

.modal-close-btn {
   float: right;
   margin-right: 5px;
   margin-top: 5px;
   background: $error-red;
   border-radius: 30px;
   padding: 2px 6px;
   font-size: 12px;
   color: white;

   &:hover {
      cursor: pointer;
   }
}

.modal-head {
  margin-top: 0;
  font-size: 54px;
  
  text-align: center;

  .white-header {
     color: #fff;
  }

  .red-header {
     color: $error-red;
     text-transform: uppercase;
  }
}

.modal-subhead {
   text-align: center;
   font-size: 24px;
   color: #fcdb00;
   text-transform: uppercase;
}

.modal-title {
   color: $instance-font-color;
   font-size: 24px;
   text-transform: none;
}

.modal-body {
  margin: 20px 0;
  color: #fff; 
}

.modal-input {
   border-radius: 0;
   border: none;
   border-bottom: 1px solid #fcdb00;
   background: transparent;
   outline: none;
   width: 500px;
   text-align: center;
   color: $instance-font-color;
   font-size: 40px !important;
   margin-bottom: 40px;
}

.modal-error-list {
   font-size: 20px;
   color: #fcdb00;
}

.modal-text {
   &.yellow {
      color: #fcdb00;
   }
}

.modal-note {
   height: 100px;
}

.modal-foot {
   color: white;

   button {
      font-size: 14px;
   }
}

.modal-input-explain {
   font-size: 20px;
}

.modal-error-text {
   color: $error-red;
}

.modal-body-inner-container {
   display: flex;
   justify-content: center;
   align-items: center;
   margin-top: 30px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>

